<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <div class="content-box">
        <div
          class="select-box"
          style="margin-bottom: 20px"
        >
          <b-row>
            <b-col cols="12" md="3" class="mb-1">
              <el-input
                v-model="unitVal"
                style="width: 100%"
                placeholder="请输入岗位名称"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-1">
              <el-select
                v-model="checkVal"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in checkList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </b-col>
            <b-col cols="12" md="6" align="right" class="mb-1">
              <el-button
                type="primary"
                @click="searchIt"
              >筛选</el-button>
            </b-col>
          </b-row>
        </div>
        <div class="table-box">
          <el-table
            :data="tableData"
            class="responsive"
          >
            <el-table-responsive-column
              type="index"
              label="序号"
              width="60"
            />
            <el-table-responsive-column
              prop="name"
              label="岗位名称"
            />
            <el-table-responsive-column label="岗位类型">
              <template slot-scope="scope">
                <span>{{ translateUnitType(scope.row.jobType) }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column
              prop="numberOfNeed"
              label="岗位招聘人数"
            />
            <el-table-responsive-column
              prop="money"
              label="月薪"
            />
            <el-table-responsive-column label="发布时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | moment('YYYY-MM-DD') }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="审核状态">
              <template slot-scope="scope">
                <span>{{ scope.row.jobCheckStatus | translateJobCheckStatus }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="招聘状态">
              <template slot-scope="scope">
                <span>{{ scope.row.jobRecruitStatus | translateJobRecruitStatus }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column
              prop="address"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="showDetail(scope.row)"
                >岗位详情</el-button>
                <el-button
                  v-if="scope.row.jobRecruitStatus === 3"
                  type="text"
                  @click="releaseUnitBtn(scope.row)"
                >再次发布</el-button>
              </template>
            </el-table-responsive-column>
          </el-table>
        </div>
        <div class="pagantion-box">
          <el-pagination
            :current-page="currentPage + 1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalSize"
            @current-change="handleCurrentChange"
          />
        </div>
        <div class="dialog-box">
          <unitDetailDialog
            ref="unitDetailDialog"
            :unit-detail-props="unitDetailProps"
          />
        </div>
        <!-- 再次发布岗位 -->
        <releaseUnit
          ref="releaseUnit"
          title-word="发布岗位"
          :call-back-obj="callBackObj"
          @addCofirm="addCofirm"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import { jobService } from '@/api/index'
import { translateUnitType, translateFireStatus, checkName } from '@/tool/utils'
import unitDetailDialog from '@/components/UnitDetailDialog.vue'
import moment from 'moment'
import releaseUnit from './module/ReleaseUnit.vue'

export default {
  name: 'UnitHistory',
  components: {
    unitDetailDialog,
    releaseUnit,
  },
  filters: {
    translateJobCheckStatus: value => {
      const action = new Map([
        [1, '审核中'],
        [2, '审核未通过'],
        [3, '审核通过'],
      ])
      return action.get(value)
    },
    translateJobRecruitStatus: value => {
      const action = new Map([
        [0, '-'],
        [1, '招聘中'],
        [2, '已完成'],
        [3, '已完成（已关闭)'],
      ])
      return action.get(value)
    },
  },
  data() {
    return {
      currentPage: 0,
      unitVal: '',
      totalSize: 0,
      checkList: [
        { id: 'NONE', name: '全部审核状态' },
        { id: 'NEW', name: '待审核' },
        { id: 'PASS', name: '已通过' },
        { id: 'FAIL', name: '未通过' },
      ],
      checkVal: 'NONE',
      tableData: [],
      unitDetailProps: null,
      callBackObj: {},
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    translateUnitType,
    translateFireStatus,
    initPage() {
      this.queryTable()
    },
    addCofirm(params) {
      // 发布岗位新增
      jobService()._createJob(params).then(res => {
        if (res.status) {
          this.$message.success('操作成功')
          this.$refs.releaseUnit.dialogVisible = false
          // this.queryApplicationList()
          this.queryTable()
        }
      })
    },
    queryTable() {
      const params = {
        jobName: this.unitVal,
        jobStatus: this.checkVal,
        page: this.currentPage,
        size: 10,
        type: 1,
      }
      if (!checkName(this.unitVal)) {
        jobService()._jobsOfAll(params).then(res => {
          if (res.status) {
            this.tableData = res.data.content
            this.totalSize = res.data.totalElements
          }
        })
      } else {
        this.$message.warning('请输入正确单位或岗位名称')
      }
    },
    showDetail(row) {
      const params = {
        name: row.name,
        jobType: row.jobType, // 新增岗位类型
        // 有效期限： 无
        numberOfNeed: row.numberOfNeed, // 岗位招聘人数
        money: row.money, // 月薪
        teacher: row.teacher, // 指导教师
        phone: row.phone, // 联系电话
        endTime: moment(row.endTime).format('YYYY-MM-DD HH:mm:ss'),
        startTime: moment(row.startTime).format('YYYY-MM-DD HH:mm:ss'),
        pVaiName: row.pVaiName, // 固定岗位有效期
        deadTime: row.deadTime,
        jobContent: row.jobContent, // 岗位职责
        requirements: row.requirements, // 岗位要求
        jobLimitList: row.jobLimitList,
        workDesc: row.workDesc, // 工作时间说明
        numberOfWorking: row.numberOfWorking, // 在岗人数
        file: row.file ? JSON.parse(row.file) : { name: '', path: '' },
      }
      this.unitDetailProps = params
      this.$refs.unitDetailDialog.dialogVisible = true
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1
      this.queryTable()
    },
    // 筛选
    searchIt() {
      this.currentPage = 0
      this.queryTable()
    },
    releaseUnitBtn(row) {
      const params = {
        name: row.name,
        jobType: row.jobType, // 新增岗位类型
        // 有效期限： 无
        numberOfNeed: row.numberOfNeed, // 岗位招聘人数
        money: row.money, // 月薪
        teacher: row.teacher, // 指导教师
        phone: row.phone, // 联系电话
        endTime: moment(row.endTime).format('YYYY-MM-DD HH:mm:ss'),
        startTime: moment(row.startTime).format('YYYY-MM-DD HH:mm:ss'),
        pVaiName: row.pVaiName, // 固定岗位有效期
        deadTime: row.deadTime,
        jobContent: row.jobContent, // 岗位职责
        requirements: row.requirements, // 岗位要求
        jobLimitList: row.jobLimitList,
        workDesc: row.workDesc, // 工作时间说明
      }
      this.callBackObj = params
      this.$refs.releaseUnit.dialogVisible = true
      this.$refs.releaseUnit.queryFixedPositionDate()
    },
  },
}
</script>

<style scoped>
</style>
